import React from "react";

import { useAuth } from "app/hooks/useAuth";
import { Navigate, useLocation } from "react-router-dom";

function AuthGuard({ children }: { children: React.ReactNode }) {
    const { isAuthenticated } = useAuth();
    const { pathname } = useLocation();

    if (isAuthenticated) return <>{children}</>;

    return <Navigate replace to="/session/signin" state={{ from: pathname }} />;
}

export default AuthGuard;
